module.exports = __webpack_public_path__ + "static/media/18ECA14.3cbe2d15.jpg";